import { installSecurePortalStorage } from './securePortalStorage';
import { installPortalFetchInterceptor } from './portalFetchInterceptor';
import { stripAllPortalJwtsFromStorage } from './storage';
import { purgeLegacySalonPiiSessionKeys } from '../salon/utils/salonGuestPiiStore';
import { purgeLegacySalonVisitLocalStorage } from '../salon/utils/salonVisitMemoryCache';
import { purgeLegacySalonFaceSessionStorage } from '../salon/utils/salonFaceSession';
import { purgeLegacySkinFlowStateStorage } from '../salon/utils/skinFlowState';
import { purgeLegacySalonAppSessionTokenStorage } from '../salon/utils/salonAppSessionToken';
import { purgeLegacyFranchiseFlowBootstrapTokenStorage } from '../shared/franchiseFlowAuth';

/** Call once at app bootstrap before any portal code runs. */
export function bootstrapEnterpriseSecurity() {
  installSecurePortalStorage();
  installPortalFetchInterceptor();
  stripAllPortalJwtsFromStorage();
  purgeLegacySalonPiiSessionKeys();
  purgeLegacySalonVisitLocalStorage();
  purgeLegacySalonFaceSessionStorage();
  purgeLegacySkinFlowStateStorage();
  purgeLegacySalonAppSessionTokenStorage();
  purgeLegacyFranchiseFlowBootstrapTokenStorage();
}